<template>
  <div class="container-fluid no-gutters px-0 pt-0 pb-0 border-bottom toolbars-bg"
  style="z-index: 30000">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: "ActivityHeader",
}
</script>